import { Grid, Paper, Typography } from '@material-ui/core'
import React from 'react'
import { getColors } from 'lib/utils/common_utils'
export default function Overview({ title = '', data = [], gridItem }) {






    return (
        <Paper style={{ borderRadius: 5, marginRight: 13 }}>
            {title && (
                <Typography variant="body1" style={{ padding: '10px 0px 0px 15px', fontSize: "13px" }}>
                    {title}
                </Typography>
            )}
            <Grid container xs={12} paddingRight={"15px"} style={{ display: "grid", gridTemplateColumns: `repeat(${data.length},2fr)`, padding: "14px 10px 10px 0px" }}>
                {data.map((item, index) => (<Grid container>

                    <Grid xs={12} style={{
                        textAlign: "center",
                        color: getColors(item.color) || '#000',
                        fontWeight: item.fontSize ? undefined : '600',
                        fontSize: item.fontSize || '',
                        marginTop: item.fontSize ? "-10px" : "",
                        textDecoration: item.underline ? "underline" : "none"
                    }}>{item.value}</Grid>
                    <Grid xs={12} style={{
                        textAlign: "center",
                        fontSize: 11,
                        paddingTop: "15px",
                        marginTop: item.fontSize ? "-8px" : "",
                    }}>{item.name}</Grid>

                </Grid>))}

            </Grid>



        </Paper>
    )
}
